import { createFileRoute } from '@tanstack/react-router';

import { UserSettings } from './-components/UserSettings';

export const Route = createFileRoute('/_authenticated/userSettings/')({
    component: UserSettings,
});
